import { render } from "./CardCallUl.vue?vue&type=template&id=352a7963"
import script from "./CardCallUl.vue?vue&type=script&lang=js"
export * from "./CardCallUl.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__